import styled, { css } from 'styled-components';

import { resetBrowserButton } from '../../../../../Button/styles';

import { newTableTokens } from '../../../../../../tokens/components/NewTable/tokens';
import { buttonTokens } from '../../../../../../tokens/components/Button/tokens';

import { StyledIcon } from '../../../../../Icon/Icon';

/* @internal */
export const StyledTwiddleIconButton = styled.button<React.ButtonHTMLAttributes<HTMLButtonElement>>`
  ${resetBrowserButton};
  border-radius: ${newTableTokens.PinBorderRadiusBaseDefault};
  padding: 0 ${newTableTokens.TwiddleIconSpacingSmallDefault};
  margin-left: -${newTableTokens.TwiddleIconSpacingMediumDefault};
  transition-duration: 80ms;
  transition-property: box-shadow, outline;
  transition-timing-function: ease-out;

  &:focus-visible {
    outline: ${buttonTokens.BorderWidthBaseDefault} ${buttonTokens.BorderStyleBaseDefault}
      ${buttonTokens.BorderColorBaseKeyboardFocus};
    box-shadow: 0 0 0 ${buttonTokens.ShadowWidthBaseKeyboardFocus} ${buttonTokens.ShadowColorBaseKeyboardFocus};
  }

  &:hover {
    cursor: pointer;
  }

  ${StyledIcon} svg {
    position: relative;
    transition: all 60ms ease-in;
    will-change: all;
    top: ${newTableTokens.TwiddleIconSpacingSmallDefault};

    ${({ theme }) =>
      theme.open &&
      css`
        transform: rotate(90deg);
      `}
  }
`;
